// UI representation for a single diagram file.
import { Menu, MenuItem } from "@szhsin/react-menu";
import { commandProcessor } from "command/command";
import { Icon } from "components/icon";
import { formatDistance } from "date-fns";
import { CloudFiles, openDiagram } from "file/api";
import Flags from "flags";
import { getDateFnsLocale } from "i18n_utils";
import * as React from 'react';
import { useTranslation } from "react-i18next";
import appStore from "store/store";
import { BetaTag, Tip } from "view/tooltips";
import { ShareModal } from "./share_modal";
export const DiagramFile = (props) => {
    const { t } = useTranslation();
    const [isShareModalOpen, setIsShareModalOpen] = React.useState(false);
    function openFile() {
        if (commandProcessor.hasDirtyChanges()) {
            if (confirm("This will erase your current diagram. Are you sure?") != true) {
                return;
            }
        }
        openDiagram(props.diagram, /*isTemplate*/ false);
        props.onOpen(props.diagram.id);
    }
    // Don't put onClick on the overall container because Action menu does not capture clicks!
    return React.createElement("div", { className: "file-grid-item col-12 col-sm-4 col-md-3 col-lg-2 mb-2 pr-2", onClick: openFile },
        React.createElement("div", { className: "thumbnail mb-1" },
            React.createElement(ActionMenu, Object.assign({}, props, { onShare: () => setIsShareModalOpen(true) })),
            React.createElement(ShareDetails, { diagram: props.diagram }),
            React.createElement("img", { src: props.diagram.thumbnail, className: "img-thumbnail" })),
        props.diagram.title,
        React.createElement("br", null),
        React.createElement("small", { className: "text-muted" },
            React.createElement("i", { className: "fa fa-clock fa-fw" }),
            " ",
            t("ui.ago", { time: formatDistance(props.diagram.modified, props.now, { locale: getDateFnsLocale() }) })),
        React.createElement(ShareModal, { isOpen: isShareModalOpen, setIsOpen: setIsShareModalOpen, diagram: props.diagram }));
};
const ShareDetails = ({ diagram }) => {
    const loggedIn = appStore.loggedInState();
    const isOwner = loggedIn && diagram.owner === loggedIn.user.id;
    if (isOwner) {
        if (diagram.sharedWith.length > 0) {
            return React.createElement(Tip, { content: `Shared with others` },
                React.createElement("div", { className: "shareDetailsOverlay" },
                    React.createElement(Icon, { fullWidth: true, name: "d,user-group", extraClass: "mr-2" }),
                    diagram.sharedWith.length));
        }
    }
    else {
        return React.createElement(Tip, { content: "Shared with me" },
            React.createElement("div", { className: "shareDetailsOverlay" },
                React.createElement(Icon, { fullWidth: true, name: "d,user-group", extraClass: "fa-swap-opacity" }),
                React.createElement(React.Fragment, null, "\u200B")));
    }
    return null;
};
const ActionMenu = (props) => {
    const { t } = useTranslation();
    const loggedIn = appStore.loggedInState();
    function deleteFile() {
        if (!loggedIn)
            return;
        const diagram = props.diagram;
        if (!confirm(t("cloud.delete_confirm", { name: diagram.title }))) {
            return;
        }
        CloudFiles.remove(loggedIn, diagram, props.onDelete);
    }
    function renameFile() {
        if (!loggedIn)
            return;
        const title = prompt(t('cloud.rename_prompt'), props.diagram.title);
        if (title === null)
            return;
        CloudFiles.rename(loggedIn, props.diagram, title, props.onRename);
    }
    const isOwner = loggedIn && props.diagram.owner === loggedIn.user.id;
    // Stop propagation is required otherwise click events will bubble up.
    return React.createElement("div", { className: "text-white overlayButton", onClick: (e) => e.stopPropagation() },
        React.createElement(Menu, { menuButton: React.createElement("button", { type: "button", className: "btn btn-sm btn-outline-secondary" },
                React.createElement("i", { className: "fa fa-ellipsis-h" })) },
            React.createElement(MenuItem, { onClick: renameFile },
                React.createElement("i", { className: "fas fa-pencil-alt" }),
                " ",
                t('Rename')),
            Flags.isSharingEnabled && isOwner && React.createElement(MenuItem, { onClick: props.onShare },
                React.createElement("i", { className: "fas fa-share-alt" }),
                " ",
                t('Share'),
                React.createElement(BetaTag, { extraClass: "ml-2" })),
            React.createElement(MenuItem, { className: "text-danger", onClick: deleteFile },
                React.createElement("i", { className: "fas fa-trash" }),
                " ",
                t('Delete'))));
};
